<div class="order-details" (window:resize)="onresize($event)">
  <div class="row search-section d-none d-lg-block">
    <div class="col-md-9 padding-0">
      <div class="text-right burgerNav">
        <nav class="navbar iconHamBurgerExpand">
          <button class="navbar-toggler" type="button" (click)="showSideNav()" data-target="#navbarToggleExternalContent">
            <span class="icon-ico-menu"></span>
          </button>
        </nav>
      </div>
    </div>
  </div>

  <div class="row contentWrapper">
    <div class="col-md-3 padding-0 grower-column order-listing" id="navbarToggleExternalContent" [@toggleState]="panelToggle">
      <div class="row grower-left-filter">
        <div class="col-md-10 padding-r0">
          <div class="search-box-inner default-select">
            <ng-select [items]="ddlAccounts"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [loading]="accountsLoading"
                       placeholder="Select Account"
                       [(ngModel)]="SelectedAccount"
                       (change)="AccountChange($event)"
                       (clear)="AccountClear($event)"
                       class="custom-select-grower"
                       [searchFn]="accountSearchFn">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                        <span class="erp-order float-r" *ngIf="item.wfusB2BEnablement == 'Yes'">
                          <i class="fas fa-lock"></i>
                        </span>
                      </h4>
                      <p class="address" [ngOptionHighlight]="search" title="{{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-md-2 grower-btns padding-l0 ">
          <div class="btn-group" ngbDropdown placement="bottom-right" role="group" aria-label="sorting">
            <button type="button" class="btn btn-default" id="growerDealerSorting" ngbDropdownToggle>
              <i class="icon-ico-order"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="growerDealerSorting" class="sortingDropdown">
              <p>Sort By:</p>
              <button *ngIf="selectedTabIndex == 0" class="dropdown-item" id="GN" (click)="sortData('GN')" [ngClass]="{'active' : selectedItem == 'GN'}">
                Grower Name
                <i [ngClass]="{'fas fa-sort-down' : selectedItem == 'GN' && toggle}" aria-hidden="true"></i>
                <i [ngClass]="{'fas fa-sort-up' : selectedItem == 'GN' && !toggle}" aria-hidden="true"></i>
              </button>
              <button *ngIf="selectedTabIndex == 1" class="dropdown-item" id="GN" (click)="sortData('GN')" [ngClass]="{'active' : selectedItem == 'GN'}">
                Dealer Name
                <i [ngClass]="{'fas fa-sort-down' : selectedItem == 'GN' && toggle}" aria-hidden="true"></i>
                <i [ngClass]="{'fas fa-sort-up' : selectedItem == 'GN' && !toggle}" aria-hidden="true"></i>
              </button>
              <button class="dropdown-item" id="ON" (click)="sortData('ON')" [ngClass]="{'active' : selectedItem == 'ON'}">
                Order Number
                <i [ngClass]="{'fas fa-sort-down' : selectedItem == 'ON' && toggle}" aria-hidden="true"></i>
                <i [ngClass]="{'fas fa-sort-up' : selectedItem == 'ON' && !toggle}" aria-hidden="true"></i>
              </button>
              <button class="dropdown-item" id="UD" (click)="sortData('UD')" [ngClass]="{'active' : selectedItem == 'UD'}">
                Last Updated
                <i [ngClass]="{'fas fa-sort-down' : selectedItem == 'UD' && toggle}" aria-hidden="true"></i>
                <i [ngClass]="{'fas fa-sort-up' : selectedItem == 'UD' && !toggle}" aria-hidden="true"></i>
              </button>
              <button class="dropdown-item" id="UQ" (click)="sortData('UQ')" [ngClass]="{'active' : selectedItem == 'UQ'}">
                Units
                <i [ngClass]="{'fas fa-sort-down' : selectedItem == 'UQ' && toggle}" aria-hidden="true"></i>
                <i [ngClass]="{'fas fa-sort-up' : selectedItem == 'UQ' && !toggle}" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs" [(selectedIndex)]="selectedTabIndex">
        <mat-tab *ngIf="growerAccessTypeMode">
          <ng-template mat-tab-label>
            <!--<i class="fas fa-list" aria-hidden="true"></i>-->
            <div class="tab-head">
              <h4>
                Grower Orders
              </h4>
            </div>
          </ng-template>
          <div class="row">
            <div class="col-md-12 ">
              <div class="grower-listing">
                <ul class="growersListing">
                  <!--<li class="active" *ngFor="let gwr of growerList">-->
                  <li id="{{gwr.growerOrderId}}" *ngFor="let gwr of growerList" (click)="GrowerChange(gwr)" [ngClass]="{'active' : isSelected == gwr.growerOrderId}">
                    <div class="row">
                      <div class="col-md-9 grower-name padding-r5" matTooltip="{{gwr.growerName}}, {{gwr.city}} - {{gwr.state}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                        {{gwr.growerName}}, {{gwr.city}} - {{gwr.state}}
                      </div>
                      <div class="col-md-3 quantity text-right padding-l5">
                        {{commonService.getFormatedNumber(gwr.unit) | number}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-9 grower-name padding-r5" matTooltip="{{gwr.shipToAccount}} - {{gwr.dealerName}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                        {{gwr.shipToAccount}} - {{gwr.dealerName}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-8 grower-id padding-r5">
                        {{gwr.orderID}}
                      </div>
                      <div class="col-md-4 date text-right padding-l5">
                        <span class="erp-order" *ngIf="gwr.orderType != 'WB' || gwr.wfusB2BEnablement == 'Yes'">
                          <i class="fas fa-lock"></i>
                        </span>
                        {{gwr.lastUpdatedAt | date : short}}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="dealerAccessTypeMode">
          <ng-template mat-tab-label>
            <!--<i class="fas fa-list" aria-hidden="true"></i>-->
            <div class="tab-head">
              <h4>
                Dealer Orders
              </h4>
            </div>
          </ng-template>
          <div class="row">
            <div class="col-md-12 ">
              <div class="grower-listing">
                <!--DealerListing-->
                <ul class="dealersListing">
                  <!--<li class="active" *ngFor="let gwr of growerList">-->
                  <!--<li *ngFor="let gwr of dealerOrderList" (click)="GrowerChange(gwr)" [ngClass]="{'active' : isSelected == gwr.growerOrderID}">-->
                  <li #{{dor.retailerId}} *ngFor="let dor of dealerOrderList" (click)="dealerChange(dor)" [ngClass]="{'active' : isDealerSelected == (dor.dealerOrderId || dor.shipToAccount)}">
                    <div class="row">
                      <div class="col-md-9 grower-name padding-r5" matTooltip="{{dor.retailerNameCityState}}" matTooltipClass="whiteFontCpp">
                        {{dor.retailerNameCityState}}
                      </div>
                      <div class="col-md-3 quantity text-right padding-l5">
                        {{dor.units | number}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-8 grower-id padding-r5">
                        {{dor.orderId}}
                      </div>
                      <div class="col-md-4 date text-right padding-l5">
                        {{dor.lastUpdatedAt | date :short}}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div [ngClass]="{
    'col-md-9':orderViewtoggle == false,
    'col-md-12':orderViewtoggle == true}" class="padding-0">
      <div class="breadcrumb-outer">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="javascript:void(0)" (click)="navigateToLandingPage()">Order</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item">
              <a href="javascript:void(0)" (click)="navigateToBreadcrumbs()">{{pageName}}</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{accountName}}</li>
          </ol>
        </nav>
        <div class="text-right new-order-btn-sec d-none d-md-block">
          <button mat-raised-button [style.display]="showNewGrowerOrder && accessTypeMode ? 'block' : 'none'" class="btns" color="primary" (click)="CreateNewOrder()">Create New Grower Order</button>
        </div>
      </div>
      <div id="orderView" class="order-view-sec padding-0 col-md-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
